export default __webpack_public_path__ + "static/media/islavalles2.3b174e5e.jpg";